import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Field } from '@adornis/baseql/decorators/field.js';
import { Entity } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/**
 * What a single booking pays for its group's Abrechnungsposition when it differs from the group:
 * a different price, nothing else. Name, Kürzel, Kostenstelle and Buchungskonto always come from
 * the group, which is what keeps a stale copy from ever pointing at a deleted Kostenstelle again.
 * The rhythm is the group's as well: `billedOn` means "last collection" for monthly and yearly but
 * "done for good" for once, so a booking switched mid-run was never collected again (ZVGPVQ).
 *
 * `null` is a value (Selbstauswahl), never "inherit". A booking that pays exactly what the group
 * says carries no override at all.
 */
@Entity()
export class BillingPositionOverride extends AdornisEntity {
  static override _class = 'BillingPositionOverride';

  constructor(doc: PartialEntityData<BillingPositionOverride>) {
    super(doc);
  }

  @Field(() => Int)
  public priceInCents: Maybe<number>;
}
